import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react'
import { StandaloneSearchBox, useGoogleMap } from '@react-google-maps/api';
import Box from '@mui/material/Box';

export default function GooglePlacesLookup(props) {
    const setSearchbox = props.setSearchbox;
    const onPlacesChanged = props.onPlacesChanged;
    const map = useGoogleMap();
    const inputRef = props.inputRef;

    const onLoadSearchBox = (sb) => {
        let searchBoxOptions = {
            strictBounds: true,
            autocomplete: true,
            fields: ['geometry']
        }
        sb.setOptions(searchBoxOptions);
        map.addListener("bounds_changed", () => {
            sb.setBounds(map.getBounds());
        });
        setSearchbox(sb);
    }

    return (
        <StandaloneSearchBox
            onPlacesChanged={
                onPlacesChanged
            }
            onLoad={onLoadSearchBox}
        >
            <Box  className="map-address-search">
            <input
                ref={inputRef}
                type="text"
                placeholder="Find a Intersection or Address"
                className="map-address-input"
            />
            </Box>

        </StandaloneSearchBox>
    )
}